module.exports = __webpack_public_path__ + "static/media/furniture1.b2f6a151.jpg";